module.exports = __webpack_public_path__ + "img/Ktirio-Perissos.0f7a4936.jpg";